import { useState, useEffect } from 'react'
import Alert from '@mui/material/Alert'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import styles from './styles.module.css'
import { fetchData } from '../../utils/fetch'
import { IDeploymentNotification } from '../../../../../app/entities/DeploymentNotification'

const NOTIFICATION_DISMISSED_KEY = 'deploymentNotificationDismissed'

export default function DeploymentBanner() {
  const [notification, setNotification] =
    useState<IDeploymentNotification | null>(null)
  const [dismissedId, setDismissedId] = useState<string | null>(null)

  useEffect(() => {
    // Load dismissed ID from localStorage on mount
    const dismissed = localStorage.getItem(NOTIFICATION_DISMISSED_KEY)
    if (dismissed) {
      setDismissedId(dismissed)
    }
  }, [])

  useEffect(() => {
    async function fetchNotification() {
      try {
        const response = await fetchData<IDeploymentNotification | null>({
          url: `${process.env.REACT_APP_ORIGIN}/deployment-notifications/active`,
          method: 'GET',
        })

        // If response is null or not active, clear the notification
        if (!response || !response.isActive) {
          setNotification(null)
        } else {
          setNotification(response)
          // Clear dismissal if this is a new notification
          if (dismissedId && response.objectId !== dismissedId) {
            localStorage.removeItem(NOTIFICATION_DISMISSED_KEY)
            setDismissedId(null)
          }
        }
      } catch (error) {
        console.error('Failed to fetch deployment notification:', error)
        // On error, clear notification to avoid stale banner
        setNotification(null)
      }
    }
    fetchNotification()

    const intervalId = setInterval(fetchNotification, 3 * 60 * 1000) // Refresh every 3 minutes
    return () => clearInterval(intervalId) // Cleanup on unmount
  }, [dismissedId])

  const shouldShowBanner =
    notification !== null &&
    notification.objectId !== dismissedId

  return (
    <Collapse in={shouldShowBanner}>
      <div className={styles.bannerContainer}>
        <Alert
          severity='error'
          variant='filled'
          className={styles.banner}
          action={
            <IconButton
              aria-label='close'
              color='inherit'
              size='small'
              onClick={() => {
                if (notification?.objectId) {
                  localStorage.setItem(
                    NOTIFICATION_DISMISSED_KEY,
                    notification.objectId
                  )
                  setDismissedId(notification.objectId)
                }
              }}
              className={styles.closeButton}
            >
              <CloseIcon fontSize='inherit' />
            </IconButton>
          }
        >
          <div className={styles.bannerContent}>
            <span className={styles.message}>
              {notification?.message || 'Site is being updated'}
            </span>
          </div>
        </Alert>
      </div>
    </Collapse>
  )
}
